import React, { useContext } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import avatar from '../../img/avatar.svg';

function Profile() {
    const { state } = useContext(GlobalContext);
    const { userData } = state;

    return (
        <>
            <div className='w-2/3 h-42 bg-white rounded-xl shadow-lg p-10 ml-10'>
                <div className="flex flex-col gap-y-7">
                    <div className='flex items-center gap-x-10 border-b-2 pb-5'>
                        <img alt="profile" src={userData.image_url.length < 10 ? avatar : userData.image_url} className="object-cover rounded-full h-20 w-20 " />
                        <h1 className='font-bold text-3xl'>Profile Card</h1>
                    </div>

                    <div>
                        <p>Name : {userData.name}</p>
                    </div>

                    <div>
                        <p>Email : {userData.email}</p>
                    </div>
                    <div>
                        <p>Created at : {userData.created_at}</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Profile;